<h1 class="page-title">
  Termeni și condiții
</h1>

<div class="terms">
  <p class="terms-updated">
    Ultima actualizare: 26 august 2026
  </p>

  <p class="terms-intro">
    Vă rugăm să citiți cu atenție prezentul document înainte de a utiliza site-ul
    <strong>dream-residence.ro</strong>. Accesarea, navigarea și utilizarea site-ului presupun
    cunoașterea și acceptarea integrală a termenilor și condițiilor de mai jos. Dacă nu sunteți
    de acord cu acești termeni, vă rugăm să nu utilizați site-ul.
  </p>

  <h2>1. Date de identificare</h2>

  <p>
    Site-ul dream-residence.ro este deținut și administrat de:
  </p>

  <ul class="terms-identity">
    <li>
      <strong>Denumire:</strong> HOME STORE INVESTMENT S.R.L.
    </li>
    <li>
      <strong>Sediu social:</strong> {{ agencyService.agency.address }}
    </li>
    <li>
      <strong>Cod unic de înregistrare (CUI):</strong> 29862284
    </li>
    <li>
      <strong>Cod de înregistrare în scopuri de TVA:</strong> RO29862284
    </li>
    <li>
      <strong>Nr. de ordine în Registrul Comerțului:</strong> J40/2377/2012
      (EUID: ROONRC.J2012002377402)
    </li>
    <li>
      <strong>Telefon:</strong>
      <a [href]="'tel:' + agencyService.agency.phone">
        {{ agencyService.agency.phone | beautify }}
      </a>
    </li>
    <li>
      <strong>E-mail:</strong>
      <a [href]="'mailto:' + agencyService.agency.email">
        {{ agencyService.agency.email }}
      </a>
    </li>
  </ul>

  <p>
    Denumită în continuare „Dezvoltatorul”, „Societatea” sau „noi”.
  </p>

  <h2>2. Definiții</h2>

  <ul>
    <li>
      <strong>Site</strong> – site-ul web disponibil la adresa dream-residence.ro, împreună cu
      toate subpaginile și subdomeniile sale.
    </li>
    <li>
      <strong>Utilizator</strong> – orice persoană fizică sau juridică ce accesează Site-ul,
      indiferent de motiv.
    </li>
    <li>
      <strong>Conținut</strong> – texte, imagini, randări, planuri, schițe, hărți interactive,
      materiale video, elemente grafice, mărci și orice alte materiale publicate pe Site.
    </li>
    <li>
      <strong>Date cu caracter personal</strong> – orice informații privind o persoană fizică
      identificată sau identificabilă, în sensul Regulamentului (UE) 2016/679 (GDPR).
    </li>
  </ul>

  <h2>3. Acceptarea termenilor</h2>

  <p>
    Utilizarea Site-ului constituie acceptarea expresă și neechivocă a prezentelor condiții.
    Termenii se aplică tuturor Utilizatorilor, indiferent dacă aceștia transmit sau nu date
    prin formularele disponibile pe Site.
  </p>

  <h2>4. Caracterul informativ al conținutului</h2>

  <p>
    Site-ul are exclusiv rol de prezentare a proiectului imobiliar Dream Residence. Informațiile
    publicate – inclusiv randările, planurile, suprafețele, dotările, stadiul lucrărilor,
    disponibilitatea unităților și prețurile – au caracter informativ și de prezentare comercială
    și <strong>nu constituie o ofertă fermă</strong> în sensul art. 1188 și următoarele din Codul civil.
  </p>

  <p>
    Randările și materialele vizuale au caracter ilustrativ. Elementele de finisaj, mobilier,
    amenajare exterioară și peisagistică prezentate pot diferi de realitate. Suprafețele,
    compartimentările și dotările finale sunt cele stabilite prin documentația tehnică și prin
    contractele încheiate între părți.
  </p>

  <p>
    Orice tranzacție imobiliară se realizează exclusiv în baza documentelor contractuale semnate
    între părți (promisiune de vânzare-cumpărare și/sau contract de vânzare în formă autentică),
    ale căror clauze prevalează asupra informațiilor publicate pe Site. Dezvoltatorul își rezervă
    dreptul de a modifica în orice moment conținutul, structura și disponibilitatea informațiilor
    de pe Site, fără notificare prealabilă.
  </p>

  <h2>5. Utilizarea Site-ului</h2>

  <p>
    Utilizatorul se obligă să folosească Site-ul cu bună-credință, în conformitate cu legislația
    aplicabilă și cu prezentele condiții. Este interzis, fără a se limita la:
  </p>

  <ul>
    <li>
      utilizarea Site-ului în scopuri ilegale, frauduloase sau de natură să prejudicieze
      Societatea ori terții;
    </li>
    <li>
      transmiterea de date false, incomplete sau aparținând altor persoane fără acordul acestora;
    </li>
    <li>
      copierea, reproducerea sau extragerea automată a Conținutului prin roboți, scripturi
      sau alte mijloace automate;
    </li>
    <li>
      orice acțiune de natură să afecteze funcționarea, securitatea sau disponibilitatea
      Site-ului ori a infrastructurii pe care acesta rulează;
    </li>
    <li>
      încercarea de acces neautorizat la conturi, servere sau rețele asociate Site-ului.
    </li>
  </ul>

  <h2>6. Proprietate intelectuală</h2>

  <p>
    Întregul Conținut al Site-ului este proprietatea Societății sau a partenerilor săi și este
    protejat de legislația privind drepturile de autor și drepturile de proprietate industrială,
    în special Legea nr. 8/1996 privind dreptul de autor și drepturile conexe.
  </p>

  <p>
    Este interzisă reproducerea, distribuirea, publicarea, modificarea, transmiterea sau
    exploatarea în orice mod a Conținutului, integral sau parțial, în scopuri comerciale, fără
    acordul scris prealabil al Societății. Utilizatorul poate consulta și tipări Conținutul
    exclusiv pentru uz personal, necomercial, cu păstrarea mențiunilor privind sursa.
  </p>

  <h2>7. Prelucrarea datelor cu caracter personal</h2>

  <p>
    Societatea prelucrează datele cu caracter personal în conformitate cu Regulamentul (UE)
    2016/679 (GDPR) și cu legislația națională aplicabilă. Datele transmise prin formularele de
    contact de pe Site (nume, număr de telefon, adresă de e-mail și orice alte informații
    comunicate voluntar) sunt prelucrate în următoarele scopuri:
  </p>

  <ul>
    <li>
      transmiterea de informații despre proiect și despre unitățile locative disponibile,
      la solicitarea Utilizatorului;
    </li>
    <li>
      contactarea Utilizatorului și programarea vizionărilor;
    </li>
    <li>
      încheierea și executarea eventualelor raporturi contractuale;
    </li>
    <li>
      îndeplinirea obligațiilor legale ce revin Societății.
    </li>
  </ul>

  <p>
    Temeiul prelucrării îl constituie, după caz, consimțământul Utilizatorului
    (art. 6 alin. 1 lit. a GDPR), demersurile precontractuale și executarea contractului
    (art. 6 alin. 1 lit. b GDPR), obligațiile legale (art. 6 alin. 1 lit. c GDPR) sau interesul
    legitim al Societății (art. 6 alin. 1 lit. f GDPR).
  </p>

  <p>
    Datele sunt păstrate pe durata necesară îndeplinirii scopurilor menționate și pe perioada
    impusă de obligațiile legale de arhivare. Datele pot fi comunicate furnizorilor de servicii
    ai Societății (găzduire, mentenanță IT, servicii de marketing, consultanță juridică sau
    contabilă), care acționează în calitate de persoane împuternicite și sunt ținuți de obligații
    de confidențialitate.
  </p>

  <p>
    În calitate de persoană vizată, beneficiați de dreptul de acces, de rectificare, de ștergere,
    de restricționare a prelucrării, de portabilitate a datelor, de opoziție, precum și de dreptul
    de a nu face obiectul unei decizii bazate exclusiv pe prelucrarea automată. Vă puteți retrage
    oricând consimțământul, fără a afecta legalitatea prelucrării efectuate anterior retragerii.
  </p>

  <p>
    Aceste drepturi pot fi exercitate printr-o solicitare transmisă la adresa
    <a [href]="'mailto:' + agencyService.agency.email">{{ agencyService.agency.email }}</a>.
    De asemenea, aveți dreptul de a depune o plângere la Autoritatea Națională de Supraveghere a
    Prelucrării Datelor cu Caracter Personal (ANSPDCP),
    <a
      href="https://www.dataprotection.ro/"
      target="_blank"
      rel="noopener noreferrer"
    >
      www.dataprotection.ro
    </a>.
  </p>

  <h2>8. Cookie-uri</h2>

  <p>
    Site-ul utilizează cookie-uri și tehnologii similare pentru a asigura funcționarea corectă a
    paginilor, pentru a analiza traficul și pentru a îmbunătăți experiența de navigare, în
    conformitate cu Legea nr. 506/2004 privind prelucrarea datelor cu caracter personal și
    protecția vieții private în sectorul comunicațiilor electronice.
  </p>

  <p>
    Cookie-urile strict necesare funcționării Site-ului sunt instalate fără a fi nevoie de
    consimțământ. Pentru celelalte categorii, Utilizatorul își poate exprima sau retrage opțiunea
    prin bannerul afișat la prima accesare. Setările privind cookie-urile pot fi modificate
    oricând din browserul folosit.
  </p>

  <h2>9. Comunicări comerciale</h2>

  <p>
    Societatea poate transmite comunicări comerciale doar către Utilizatorii care și-au exprimat
    consimțământul în acest sens, cu respectarea Legii nr. 506/2004 și a
    Ordonanței nr. 130/2000. Dezabonarea este posibilă oricând, gratuit, prin linkul dedicat din
    fiecare mesaj sau printr-o solicitare transmisă la adresa de e-mail indicată mai sus.
  </p>

  <h2>10. Limitarea răspunderii</h2>

  <p>
    Societatea depune eforturi rezonabile pentru ca informațiile publicate pe Site să fie corecte
    și actuale, însă nu garantează caracterul complet, exact sau permanent actualizat al acestora.
  </p>

  <p>
    Societatea nu răspunde pentru eventualele prejudicii directe sau indirecte rezultate din
    utilizarea sau imposibilitatea utilizării Site-ului, din erori, omisiuni, întreruperi,
    defecțiuni tehnice, viruși informatici sau din decizii luate exclusiv pe baza informațiilor
    publicate pe Site, în limitele permise de lege. Prezenta clauză nu limitează răspunderea
    Societății în cazurile în care legea nu permite o astfel de limitare.
  </p>

  <h2>11. Linkuri către site-uri terțe</h2>

  <p>
    Site-ul poate conține linkuri către site-uri administrate de terți. Societatea nu controlează
    și nu își asumă răspunderea pentru conținutul, politicile de confidențialitate sau practicile
    acestor site-uri. Accesarea lor se face pe răspunderea Utilizatorului.
  </p>

  <h2>12. Disponibilitatea Site-ului</h2>

  <p>
    Societatea nu garantează funcționarea neîntreruptă și fără erori a Site-ului și își rezervă
    dreptul de a suspenda temporar accesul pentru operațiuni de mentenanță, actualizare sau din
    motive de securitate, fără notificare prealabilă.
  </p>

  <h2>13. Forță majoră</h2>

  <p>
    Niciuna dintre părți nu răspunde pentru neexecutarea obligațiilor sale dacă aceasta se
    datorează unui eveniment de forță majoră sau caz fortuit, în condițiile legii.
  </p>

  <h2>14. Modificarea termenilor</h2>

  <p>
    Societatea își rezervă dreptul de a modifica oricând prezentele condiții. Versiunea aplicabilă
    este cea publicată pe Site la momentul accesării, data ultimei actualizări fiind indicată la
    începutul acestui document. Vă recomandăm consultarea periodică a acestei pagini.
  </p>

  <h2>15. Soluționarea litigiilor</h2>

  <p>
    Eventualele neînțelegeri se soluționează pe cale amiabilă. Sesizările pot fi transmise la
    adresa <a [href]="'mailto:' + agencyService.agency.email">{{ agencyService.agency.email }}</a>,
    urmând a primi un răspuns în termenul prevăzut de lege.
  </p>

  <p>
    În cazul în care nu se ajunge la o soluție amiabilă, Utilizatorul care are calitatea de
    consumator se poate adresa:
  </p>

  <ul>
    <li>
      Autorității Naționale pentru Protecția Consumatorilor (ANPC),
      <a
        href="https://anpc.ro/"
        target="_blank"
        rel="noopener noreferrer"
      >
        anpc.ro
      </a>;
    </li>
    <li>
      entităților de Soluționare Alternativă a Litigiilor (SAL), conform
      Ordonanței Guvernului nr. 38/2015 –
      <a
        href="https://anpc.ro/ce-este-sal/"
        target="_blank"
        rel="noopener noreferrer"
      >
        anpc.ro/ce-este-sal
      </a>;
    </li>
    <li>
      platformei europene de Soluționare Online a Litigiilor (SOL), conform
      Regulamentului (UE) nr. 524/2013 –
      <a
        href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO"
        target="_blank"
        rel="noopener noreferrer"
      >
        platforma SOL
      </a>.
    </li>
  </ul>

  <h2>16. Legea aplicabilă</h2>

  <p>
    Prezentele condiții sunt guvernate de legea română. Orice litigiu care nu poate fi soluționat
    pe cale amiabilă va fi supus instanțelor judecătorești competente de la sediul Societății,
    cu respectarea normelor imperative privind competența în materia protecției consumatorilor.
  </p>

  <h2>17. Contact</h2>

  <p>
    Pentru orice întrebare privind prezentele condiții ne puteți contacta la
    <a [href]="'mailto:' + agencyService.agency.email">{{ agencyService.agency.email }}</a>
    sau la numărul de telefon
    <a [href]="'tel:' + agencyService.agency.phone">{{ agencyService.agency.phone | beautify }}</a>.
  </p>
</div>



// WEBPACK FOOTER //
// ./src/app/terms/terms.component.html